import useLastMessages from '@hooks/xmpp/useLastMessages';
import { removeAccents } from '@lib/utils/strings';
import { Empty } from '@ui';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import LoadingOverlay from '../../../../components/loading-overlay';
import ChatPreviewItem from './chat-preview-item';
import { ChatPreviewSC } from './chat-preview.styled';

type TProps = {
  query: string;
};

const ChatPreview: React.FC<TProps> = ({ query }) => {
  const { inbox, isLoading } = useLastMessages();

  if (inbox.length === 0) {
    return (
      <LoadingOverlay loading={isLoading} background="GREY">
        <Empty
          title="Žiadne správy"
          description={<FormattedMessage id="chat.no_incoming_messages" />}
          className="no-entries"
          style={{ padding: 32 }}
        />
      </LoadingOverlay>
    );
  }

  return (
    <ChatPreviewSC>
      {(query !== ''
        ? inbox.filter((i) =>
            removeAccents(i.fullName)
              ?.toLocaleLowerCase()!
              .includes(removeAccents(query)!.toLocaleLowerCase()),
          )
        : inbox
      ).map((m) => (
        <ChatPreviewItem key={m.patient?.id} item={m} query={query} />
      ))}
    </ChatPreviewSC>
  );
};

export default ChatPreview;
